import { render, staticRenderFns } from "./IvaBreakdown.vue?vue&type=template&id=76494022&"
import script from "./IvaBreakdown.vue?vue&type=script&lang=js&"
export * from "./IvaBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports